import React from "react";
import styles from "./AuthLayout.module.scss";
import { Text, type TextProps } from "@mantine/core";
import { Link as RouterLink } from "react-router-dom";

export const LogoContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, className, ...rest }) => (
  <div className={`${styles.logoContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const LoginContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, className, ...rest }) => (
  <div className={`${styles.loginContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const DarkBox: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, className, ...rest }) => (
  <div className={`${styles.darkBox} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const LoginFooter: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, className, ...rest }) => (
  <div className={`${styles.loginFooter} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const FooterText: React.FC<React.ComponentProps<typeof Text>> = ({
  children,
  className,
  ...rest
}) => (
  <Text className={`${styles.footerText} ${className ?? ""}`} {...rest}>
    {children}
  </Text>
);

export const Link: React.FC<any> = props => (
  <RouterLink className={styles.link} {...props} />
);
